import {Children} from "interfaces";
import {useTheme} from "styled-components";
import {Panel, Sidebar, TopBar} from "./lib";
import {toggleMobileMenu} from "global/slices";
import {Absolute, IconButton} from "components";
import {RouteOutlined} from "@mui/icons-material";
import {Container, Content, Grid, Main} from "./styled";
import {useBreakpoints, useAppDispatch, useAppSelector} from "hooks";

interface AuthLayoutProps extends Children {}

export const AuthLayout: React.FC<AuthLayoutProps> = ({children}) => {
  const dispatch = useAppDispatch();
  const {primary, black} = useTheme();
  const {upLg, downLg} = useBreakpoints();
  const {menuExpanded, panel} = useAppSelector("layout");
  const {opened, width} = panel;

  return (
    <Container
      style={{
        gridTemplateColumns: upLg
          ? `${menuExpanded ? "280px" : "78px"} auto`
          : "1fr",
      }}
    >
      {upLg && <Sidebar />}
      <Main>
        <TopBar />
        <Grid
          style={{
            gridTemplateColumns: upLg
              ? `auto ${opened ? width : "0px"}`
              : "auto",
          }}
        >
          <Content id="scrollable">{children}</Content>
          <Panel />
        </Grid>
      </Main>
      {downLg && (
        <Absolute bottom={10} right={10} zIndex={9} position="fixed">
          <IconButton
            size={60}
            backgroundColor={primary}
            onClick={() => dispatch(toggleMobileMenu(true))}
            icon={<RouteOutlined style={{color: black}} />}
          />
        </Absolute>
      )}
    </Container>
  );
};
